export const PASSWORDS_MISMATCH_MESSAGE = 'Password and Confirm Password do not match';

const VALIDATION_FAILED_MESSAGE = 'Validation Failed';

type AuthErrorDetails = Record<string, unknown> | Array<Record<string, unknown>>;

type AuthErrorData = {
  message?: unknown;
  password?: unknown;
  newPassword?: unknown;
  details?: AuthErrorDetails;
};

type AuthErrorResponse = {
  data?: AuthErrorData | string;
  message?: unknown;
};

const firstStringValue = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }
  if (Array.isArray(value)) {
    return firstStringValue(value[0]);
  }
  return null;
};

const getUsefulMessage = (value: unknown): string | null => {
  const message = firstStringValue(value);
  if (!message || message === VALIDATION_FAILED_MESSAGE) {
    return null;
  }
  return message;
};

const getDetailMessage = (details?: AuthErrorDetails): string | null => {
  if (!details) {
    return null;
  }

  if (Array.isArray(details)) {
    for (const detail of details) {
      const message = getUsefulMessage(detail.password) || getUsefulMessage(detail.newPassword);
      if (message) {
        return message;
      }
      const firstValue = getUsefulMessage(Object.values(detail)[0]);
      if (firstValue) {
        return firstValue;
      }
    }
    return null;
  }

  return (
    getUsefulMessage(details.password) ||
    getUsefulMessage(details.newPassword) ||
    getUsefulMessage(Object.values(details)[0])
  );
};

export const getPasswordFormError = (password: string, confirmPassword: string): string | null => {
  if (password !== confirmPassword) {
    return PASSWORDS_MISMATCH_MESSAGE;
  }

  return null;
};

export const getAuthPasswordErrorMessage = (
  response: AuthErrorResponse | null | undefined,
  fallback: string,
): string => {
  const data = response?.data;

  if (typeof data === 'string') {
    return getUsefulMessage(data) || fallback;
  }

  if (data && typeof data === 'object') {
    const fieldMessage = getUsefulMessage(data.password) || getUsefulMessage(data.newPassword);
    if (fieldMessage) {
      return fieldMessage;
    }

    const detailMessage = getDetailMessage(data.details);
    if (detailMessage) {
      return detailMessage;
    }

    const dataMessage = getUsefulMessage(data.message);
    if (dataMessage) {
      return dataMessage;
    }
  }

  const responseMessage = getUsefulMessage(response?.message);
  if (responseMessage) {
    return responseMessage;
  }

  return fallback;
};
